import { Routes, Route } from 'react-router-dom';
import Home from '@/pages/Home';
import NewGame from '@/pages/NewGame';
import Game from '@/pages/Game';
import ToastContainer from '@/components/ui/ToastContainer';

function App() {
  return (
    <div className="min-h-screen w-full bg-[#1a1a2e] text-[#eaeaea]">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/new-game" element={<NewGame />} />
        <Route path="/game" element={<Game />} />
      </Routes>

      {/* Toast notifications */}
      <ToastContainer />
    </div>
  );
}

export default App;
